/* jQuery lightbox script for displaying images, videos and more. Touch enabled, responsive and fully customizable. */

// Dependencies
import $ from 'jquery';
require('../plugins/jquery.fancybox.js');

const google = window.google;

const $el = {
	modal: $('[data-fancybox]'),
	modalMap: $('.js-modal-map'),
	mapPin: '/images/elements/map-pin.png'
};

// Module events
export default function init() {
	
	$el.modal.fancybox({
		// Options will go here
		focus: false
	});
	
	$el.modalMap.each(function(index) {
		index = index + 1;
		const $this = $(this);
		const id = $this.attr('href').substr(1);
		const lat = $this.data('lat');
		const long = $this.data('long');
		const latLong = new google.maps.LatLng(lat, long);

		const map = new google.maps.Map(
			document.querySelector(`#map-canvas-${id}`), {
				zoom: 9,
				center: latLong,
				gestureHandling: 'cooperative'
				// mapTypeId: google.maps.MapTypeId.TERRAIN
			}   
		);
		
		const marker = new google.maps.Marker({
			position: latLong,
			icon: $el.mapPin,
			map
		});
		
		$this.fancybox({
			hideOnContentClick: false, // so you can handle the map
			overlayColor: '#ccffee',
			overlayOpacity: 0.8,
			autoDimensions: true, // the selector #mapcontainer HAS css width and height
			onComplete: () => {
				google.maps.event.trigger(map, 'resize');
				// $('#fancybox-close').css( {
				// 	'opacity':0.5
				// });
			},
			onCleanup: () => {
				const myContent = this.href;
				$(myContent).unwrap();
			} // fixes inline bug
		});
		
	});
	
}

